import { axios } from '@lib/axios';

import {
    SipConfigurationResponse,
    SipConfigurationsData,
    ServicesConfigurationResponse,
    ServicesConfigurationsData,
    ReceiptPrinterConfigurationResponse,
    ReceiptPrinterConfigurationData,
    SupportConfigurationResponse,
    SupportConfigurationData,
    FeatureUpdateData,
    FeatureData,
} from 'chaika-frontend-types/frontend-cms';
import { FeatureName } from 'chaika-enums';
import { TranslationDataResponse, TranslationDataViewModel, TranslationsDataParams } from 'chaika-types';

const BASE_URL = '/api/configuration';

export class ConfigurationApi {
    public static async getSipConfig(): Promise<SipConfigurationsData> {
        const res = await axios.get<SipConfigurationResponse>(`${BASE_URL}/sip`);

        return res.data.sip;
    }

    public static async getServicesConfig(): Promise<ServicesConfigurationsData> {
        const res = await axios.get<ServicesConfigurationResponse>(`${BASE_URL}/services`);

        return res.data.services;
    }

    public static async getReceiptPrinterConfig(): Promise<ReceiptPrinterConfigurationData> {
        const res = await axios.get<ReceiptPrinterConfigurationResponse>(`${BASE_URL}/receipt-printer`);

        return res.data.receiptPrinter;
    }

    public static async getSupportConfig(): Promise<SupportConfigurationData> {
        const res = await axios.get<SupportConfigurationResponse>(`${BASE_URL}/support`);

        return res.data.support;
    }

    public static async getFeatures(): Promise<FeatureData[]> {
        const res = await axios.get(`${BASE_URL}/feature`);

        return res.data.features;
    }

    public static async updateFeature(name: FeatureName, feature: FeatureUpdateData): Promise<void> {
        await axios.put(`${BASE_URL}/feature/${name}`, { feature });
    }

    public static async getTranslationData(): Promise<TranslationDataViewModel[]> {
        const res = await axios.get<TranslationDataResponse>(`${BASE_URL}/translation-data`);

        return res.data.translationData;
    }

    public static async updateTranslationData(translationKey: string, params: TranslationsDataParams): Promise<void> {
        await axios.put(`${BASE_URL}/translation-data/${translationKey}`, params);
    }
}

export { BASE_URL as CONFIGURATION_BASE_URL };
